<template>
  <header>
    <div class="wrapper">
      
      <h1><a href="/">Pastel World</a></h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style lang="scss">
$headerSize: 80px;
$clear_blue: #99d6ff;
header {
  position: sticky;
  z-index: 1;
  top:0;
  background: $clear_blue;
  height: $headerSize;
  color: #eaf4fc;
  filter: drop-shadow(0 0 3px $clear_blue);
}
h1 {
  margin: 0;
  line-height: $headerSize;
}
a {
  text-decoration: none;
  color: #eaf4fc;
}
</style>
